import { render } from "./situation_new4.vue?vue&type=template&id=56b9663d&scoped=true"
import script from "./situation_new4.vue?vue&type=script&lang=js"
export * from "./situation_new4.vue?vue&type=script&lang=js"

import "./situation_new4.vue?vue&type=style&index=0&id=56b9663d&lang=scss&scoped=scoped"
import "./situation_new4.vue?vue&type=style&index=1&id=56b9663d&scoped=true&lang=css"

import exportComponent from "/Users/cw/Desktop/BME/screen_project_315/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56b9663d"]])

export default __exports__